import Link from 'next/link'
import styles from './covidWarning.module.css'

export default function CovidWarning() {
    const showCovidWarning = process.env.NEXT_PUBLIC_COVID_WARNING;
    return (
        <>
            {showCovidWarning && (
            <div className= {`${styles.sticky} ${styles.background}`}>
                <div className="container">
                    <div className={styles.content}>
                        <strong>COVID-19 Update:</strong> Filing date moved to July 15th. Extensions available through
                        October 15th.
                    </div>
                </div>
            </div>
            )}
        </>
    )
}
